module.exports = __webpack_public_path__ + "img/assessment.516126ee.svg";